var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fullHeightViewport backgroundLogin pa-0",style:(`
    display: flex;
    flex-direction: row;`),attrs:{"fluid":""}},[_c('div',{staticClass:"container-text",domProps:{"innerHTML":_vm._s(_vm.$t('modules.login.signIn.titleLogin'))}}),_c('v-container',{staticClass:"container-custom pa-0",staticStyle:{"flex":"2"}},[_c('v-row',{staticStyle:{"justify-content":"center"},attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"mx-auto mx-sm-0",attrs:{"cols":"10","md":"4","sm":"6"}},[_c('router-view',{attrs:{"logoPath":_vm.logoPath}})],1)],1)],1),_c('v-container',{staticClass:"backgroundLogin",style:(`
    flex: 3;
    background-image: url(${_vm.appPath});
    background-size: cover;
    clip-path: polygon(15% 0, 100% 0, 100% 100%, 15% 100%, 0 50%)
  `)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }